import { render, staticRenderFns } from "./FmlTextField.vue?vue&type=template&id=2f85ed38&"
import script from "./FmlTextField.vue?vue&type=script&lang=js&"
export * from "./FmlTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports